import { useNavigate } from "react-router-dom";
import { ArrowLeft, Bell, Moon, Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";
import { useTheme } from "@/lib/theme";

export default function AppHeader({ title, showBack = false, right = null, showLogo = false }) {
  const nav = useNavigate();
  const { resolved, toggle } = useTheme();
  const isDark = resolved === "dark";
  return (
    <header className="sticky top-0 z-30 glass border-b border-border safe-top">
      <div className="max-w-md mx-auto px-4 h-14 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 min-w-0">
          {showBack ? (
            <Button
              variant="ghost"
              size="icon"
              data-testid="header-back"
              onClick={() => nav(-1)}
              className="rounded-full h-9 w-9"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
          ) : null}
          {showLogo && <Logo size={32} variant="mark" testId="header-logo" />}
          <h1 className="font-display font-bold text-lg truncate" data-testid="header-title">
            {title}
          </h1>
        </div>
        <div className="flex items-center gap-1">
          {right}
          <Button
            variant="ghost"
            size="icon"
            data-testid="header-theme-toggle"
            onClick={toggle}
            className="rounded-full h-9 w-9"
            aria-label={isDark ? "Aydınlık moda geç" : "Karanlık moda geç"}
          >
            {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
          </Button>
          <Button
            variant="ghost"
            size="icon"
            data-testid="header-bell"
            onClick={() => nav("/bildirimler")}
            className="rounded-full h-9 w-9"
            aria-label="Bildirimler"
          >
            <Bell className="h-5 w-5" />
          </Button>
        </div>
      </div>
    </header>
  );
}
